import React, { useState } from 'react';
import { Tab, Form, Input, Button } from '@alifd/next';
import moment from 'moment';
import styles from '../../../index.module.scss';
import LzTag from '@/components/common/LzTag';
import LzMsg from '@/components/common/LzMsg';
import LzDialog from '@/components/common/LzDialog';
import SaveCrowd from '@/components/canvas/Nodes/saveCrowd';
import { CanvasService } from '@/service';

// tab选项卡
const panes = [
  {
    tab: '详情',
    key: '0'
  },
  {
    tab: '任务',
    key: '1'
  }
];

export default ({initData = {}, runState = {}, changeData = (data) => {}, onCancel = () => {}}) => {
  // 控制保存人群包弹窗的变量
  const [ isSelectCrow, setSelectCrow ] = useState(false);
  // 保存人群包所需数据
  const [ saveCrowdData, setCrowdData ] = useState({
    name: '',
    remark: '',
    resultNumber: '',
    strategyInstId: ''
  })

  //抽取状态
  const selectTypeList = [
    {
      id: 1,
      name: '全部',
    },{
      id: 2,
      name: '发送成功',
    },{
      id: 3,
      name: '发送失败',
    },
  ];

  // Tab展示 0：详情，1：任务
  const [showTabkey, setShowTabkey] = useState('0');
  // 组件内部的数据 原表单数据
  const [data, setData] = useState({
    ...initData
  });
  // 节点运行时详情数据
  const [state, setState] = useState({
    ...runState
  });
  // 为标识节点任务执行成功后成功人群包信息是否展示
  const [isSuccessNode, setIsSuccessNode] = useState(state.variables && state.variables[0] ? true : false);

  /**
   * 点击确认, 保存人群
   */
  const confirm = (crowdInfo) =>  {
    CanvasService.saveNewCrowd(crowdInfo).then(res => {
      setSelectCrow(false);
      LzMsg.success('保存成功');
    }).catch(e => {
      console.log(e)
    })
  };

  /**
   * 点击退出保存人群弹窗
   */
  const cancel = () => {
    setSelectCrow(false);
  };

  return (
    <div className={`page-Padding ${styles.detailRoot} canvasDetailDialog`} style={{padding: '30px'}}>
      <div className="second-level">
        <Tab shape="wrapped" onChange = {setShowTabkey}>
          {
            panes.map(pane => <Tab.Item title={pane.tab} key={pane.key} className="justify-tabs-tab"/>)
          }
        </Tab>
      </div>
      {
        showTabkey === '0' &&
        <Form className={`canvasDialog ${styles.formDiv} ${styles.detailRoot} ${styles.extractRoot} canvasDetailDialog`}>
          <Form.Item label="节点ID:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{state.nodeId ? state.nodeId : '--'}</div>
          </Form.Item>
          <Form.Item label="节点名称:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{data.name}</div>
          </Form.Item>
          <Form.Item label="上级节点:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{data.preActName}</div>
          </Form.Item>
          <Form.Item label="人群抽取:">
            <div>
              <div className={`formItemWidth ${styles.lineHeightNormal}`}
                title={data.extractType}
                style={{
                    width: '290px !important',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                }}
              >
                {data.extractType}
              </div>
              <div className={`formItemWidth ${styles.crowdList} ${styles.displayFlex} ${styles.crowdNumber}`}>
                <span>人群数量: {isSuccessNode && state.variables[0].resultNum ? state.variables[0].resultNum : '--'}人</span>
                {/* {
                  isSuccessNode && state.variables[0].resultNum && <span className={styles.globalLink} onClick={() => {setCrowdData({...saveCrowdData, resultNumber: state.variables[0].resultNum, strategyInstId: state.variables[0].searchId}), setSelectCrow(true)}}>保存人群包</span>
                } */}
              </div>
            </div>
          </Form.Item>
          <Form.Item label="备注:">
            <div className={`formItemWidth canvas-node-remark ${styles.lineHeightNormal}`}>{data.remark}</div>
          </Form.Item>
        </Form>
      }
      {
        showTabkey === '1' && <Form className={`${styles.formDiv} canvasDialog`}>
          <Form.Item label="任务ID:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{state.activityInfo && state.activityInfo.jobId ? state.activityInfo.jobId : '--'}</div>
          </Form.Item>
          <Form.Item label="任务执行周期:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{(state.activityInfo && state.activityInfo.startTime) ? `${moment(state.activityInfo.startTime).format('YYYY-MM-DD HH:mm:ss')} 至 ` : '--'}{(state.activityInfo && state.activityInfo.endTime && state.activityInfo.endTime !== -1) ? moment(state.activityInfo.endTime).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
          </Form.Item>
          <Form.Item label="状态:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>
              {
                (state.activityInfo && state.activityInfo.endTime && state.activityInfo.endTime !== -1 && !state.activityInfo.errorMsg) && <LzTag.Success>执行成功</LzTag.Success>
              }
              {
                ((state.activityInfo && state.activityInfo.startTime && state.activityInfo.endTime === -1 && !state.activityInfo.errorMsg)) && <LzTag.Success>执行中...</LzTag.Success>
              }
              {
                (!state.activityInfo || JSON.stringify(state.activityInfo) === '{}') && <LzTag.Warning>未执行</LzTag.Warning>
              }
              {
                (state.activityInfo && state.activityInfo.errorMsg) && <LzTag.Error>执行失败 {state.activityInfo.errorMsg}</LzTag.Error>
              }
            </div>
          </Form.Item>
        </Form>
      }
      <LzDialog footer={false} shouldUpdatePosition title="保存人群包" visible={isSelectCrow}
        onCancel={() => setSelectCrow(false)}
        onClose={() => setSelectCrow(false)}>
        <SaveCrowd saveCrowdData={saveCrowdData} confirm={(crowdInfo) => confirm(crowdInfo)} cancel={cancel}/>
      </LzDialog>
    </div>
  )
}
